import { numberToWords } from "./numberToWords";

const InvoiceTemplate = ({ invoice }) => {
    const amountInWords = numberToWords(invoice.total);

  return (
    <div className="p-6 w-[210mm] min-h-[297mm] mx-auto bg-white text-xs border border-black">
      
      <div className="text-center mb-2">
        <h1 className="text-lg font-bold">COEFFICIENT PARTNERS</h1>
        <p>GST No. ASDF23486DD</p>
        <p>C - 56/5, Second Floor, Mantech Tower, Block B, Industrial Area, Sector 62, Noida Uttar pradesh 201309</p>
        <p>e-mail: info@coefficient.com, Ph. +91 93198 98369,</p>
        <p><b>State Name :</b> Uttar pradesh, <b>State Code :</b> UP</p>
      </div>

      <div className="border border-black">
        <div className="grid grid-cols-2">
          <div className="border-r border-black p-1">
            <p><b>Client Name :</b> {invoice.customerName}</p>
            <p><b>Address :</b> {invoice.shippingAddress || "H-195, Sarita Vihar, New Delhi 110076"}</p>
            <p><b>GSTIN :</b> {invoice.sellerGstin}</p>
          </div>
          <div className="p-1">
            <p><b>Date :</b> {invoice.invoiceDate}</p>
            <p><b>Invoice No :</b> {invoice.id}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 border-t border-black">
          <div className="border-r border-black p-1">
            <p><b>Delivery Address</b></p>
            <p><b>Client Name :</b> {invoice.customerName}</p>
            <p><b>Address :</b> {invoice.shippingAddress || "H-195, Sarita Vihar, New Delhi 110076"}</p>
            <p><b>GSTIN :</b> {invoice.customerGstin}</p>
          </div>
          <div className="p-1">
            <p><b>State Name :</b> {invoice.sellerState}</p>
          </div>
        </div>
      </div>

      <table className="w-full border border-black mt-1">
        <thead>
          <tr>
            <th className="border border-black p-1">S.No</th>
            <th className="border border-black p-1">Description</th>
            <th className="border border-black p-1">HSN Code</th>
            <th className="border border-black p-1">Qty</th>
            <th className="border border-black p-1">Rate</th>
            <th className="border border-black p-1">Amount</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items.map((item, i) => (
            <tr key={i} className="h-6">
              <td className="border border-black p-1 text-center">{i + 1}</td>
              <td className="border border-black p-1">{item.name}</td>
              <td className="border border-black p-1 text-center">{item.hsn || "-"}</td>
              <td className="border border-black p-1 text-center">{item.qty}</td>
              <td className="border border-black p-1 text-right">{item.rate}</td>
              <td className="border border-black p-1 text-right">
                {Number(item.qty) * Number(item.rate)}
              </td>
            </tr>
          ))}

          {Array.from({ length: 6 }).map((_, i) => (
            <tr key={`empty-${i}`} className="h-6">
              <td className="border border-black"></td>
              <td className="border border-black"></td>
              <td className="border border-black"></td>
              <td className="border border-black"></td>
              <td className="border border-black"></td>
              <td className="border border-black"></td>
            </tr>
          ))}
        </tbody>
      </table>

      <table className="w-full border border-black border-t-0">
        <tbody>
          {/* <tr>
            <td colSpan="5" className="border border-black p-1 text-right">
              <b>Total Value</b>
            </td>
            <td className="border border-black p-1 text-right">
              {invoice.subTotal || invoice.total}
            </td>
          </tr> */}
          <tr>
            <td colSpan="5" className="border border-black p-1 text-right">
               Total Discount
            </td>
            <td className="border border-black p-1 text-right">
              {invoice.items[0].discount || "0"}
            </td>
          </tr>
          <tr>
            <td colSpan="5" className="border border-black p-1 text-right">
              Add : GST %
            </td>
            <td className="border border-black p-1 text-right">
              {invoice.items[0].gstRate || "0"}%
            </td>
          </tr>
          <tr>
            <td colSpan="5" className="border border-black p-1 text-right font-bold">
              Grand Total
            </td>
            <td className="border border-black p-1 text-right font-bold">
              ₹ {invoice.total}
            </td>
          </tr>
        </tbody>
      </table>

            <div className="mt-3">
          <p><b>Amount in Words :</b>{amountInWords}</p>
        </div>


      <div className="flex justify-end mt-8">
        <div className="text-center">
          <p><b>For COEFFICIENT PARTNERS</b></p>
          <div className="mt-10">
            <p>Authorised Signature</p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default InvoiceTemplate;
